import { useTranslation } from 'react-i18next';

import { Badge } from '@/components/ui/badge';
import { Tooltip } from '@/components/ui/tooltip';
import { useHealth } from '@/hooks/use-health';

/**
 * Whether this console can actually reach its API.
 *
 * Sitting in the gallery for Phase 0 because it is the end-to-end proof that the
 * fetch client, the CORS allowlist and the versioned prefix all line up. It moves
 * into the app shell once there is one.
 */
export const ApiStatus = () => {
  const { t } = useTranslation('gallery');
  const { data, isPending, isError } = useHealth();

  if (isPending) {
    return <Badge>{t('api.checking')}</Badge>;
  }

  if (isError) {
    return (
      <Tooltip content={t('api.unreachableHelp')}>
        <Badge variant="danger">{t('api.unreachable')}</Badge>
      </Tooltip>
    );
  }

  if (data?.checks.database !== 'ok') {
    return <Badge variant="warning">{t('api.degraded')}</Badge>;
  }

  return <Badge variant="success">{t('api.connected')}</Badge>;
};
